// extracted by mini-css-extract-plugin
export default {"accent":"answer_accent__1pNdl","container":"answer_container__4VlsB","text":"answer_text__dTGxE"};